// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lk2k","label":"styles_label__iOm53"};